module.exports = __webpack_public_path__ + "static/img/title.a741bf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/feature6/title.png
// module id = vZcr
// module chunks = 7